import { publicApi } from "@/lib/axios/instances";
import { Category } from "@/types/category";

export const fetchCategories = async (
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<Category[]> => {
  const { data } = await publicApi.get<Category[]>('/categories', config);
  return data;
};

export const fetchCategoryBySlug = async (
  slug: Category['slug'],
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<Category> => {
  const { data } = await publicApi.get<Category>(`/categories/slug/${slug}`, config);
  return data;
};
